import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  gap: 0.5,
};
